import { useState } from "react";
import "./Tab.scss";

const Tab = ({ setFilteredProjects, filters, data, setAnimateCard }) => {
  const [activeFilter, setActiveFilter] = useState("All");

  const handleProjectsFilter = (tag) => {
    setActiveFilter(tag);
    setAnimateCard({ y: 100, opacity: 0 });
    setTimeout(() => {
      setAnimateCard({ y: 0, opacity: 1 });
      if (tag === "All") {
        setFilteredProjects(data);
      } else {
        setFilteredProjects(data.filter((item) => item.tags.includes(tag)));
      }
    }, 500);
  };

  return (
    <div className="tabs">
      {filters.map((item) => (
        <div
          key={item}
          className={`tabs__item ${
            item === activeFilter ? "tabs__active" : ""
          }`}
          onClick={() => handleProjectsFilter(item)}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Tab;
